import { convertMarkdownToHtml, displayDate } from '~/plugins/functions/display'

// For DTO Contact
export interface IModelContactResponse {
  id: string
  sourceId: string | null
  lineUserId: string | null
  facebookUserId: string | null
  whatsappUserId: string | null
  instagramUserId: string | null
  linkedinUserId: string | null
  mobileWebviewUserId: string | null
  webchatUserId: string | null
  state: string
  name: string | null
  profileImg: string | null
  lastMessageAt: string | Date
  createdAt: string | Date
  updatedAt: string | Date
  lastMessageText: string
}

export class ModelContact {
  id: string
  sourceId: string | null
  lineUserId: string | null
  facebookUserId: string | null
  whatsappUserId: string | null
  instagramUserId: string | null
  linkedinUserId: string | null
  mobileWebviewUserId: string | null
  webchatUserId: string | null
  state: string
  name: string | null
  profileImg: string | null
  lastMessageAt: string | Date
  createdAt: string | Date
  updatedAt: string | Date

  displayLastMessageAt: string
  displayCreatedAt: string
  displayUpdatedAt: string
  platform: 'line' | 'facebook' | 'whatsapp' | 'instagram' | 'linkedin' | 'mobileWebview' | 'webchat' | 'unknown'
  displayName: string
  lastMessageText: string

  constructor(props = {} as IModelContactResponse) {
    props = props ?? ({} as IModelContactResponse)
    this.id = props.id || ''
    this.sourceId = props.sourceId || null
    this.lineUserId = props.lineUserId || null
    this.facebookUserId = props.facebookUserId || null
    this.whatsappUserId = props.whatsappUserId || null
    this.instagramUserId = props.instagramUserId || null
    this.linkedinUserId = props.linkedinUserId || null
    this.mobileWebviewUserId = props.mobileWebviewUserId || null
    this.webchatUserId = props.webchatUserId || null
    this.state = props.state || ''
    this.name = props.name || null
    this.profileImg = props.profileImg || null
    this.lastMessageAt = props.lastMessageAt || ''
    this.createdAt = props.createdAt || ''
    this.updatedAt = props.updatedAt || ''

    this.displayLastMessageAt = displayDate(this.lastMessageAt, { isTime: true })
    this.displayCreatedAt = displayDate(this.createdAt, { isTime: true })
    this.displayUpdatedAt = displayDate(this.updatedAt, { isTime: true })
    this.platform = this.getPlatform()
    this.displayName = this.getDisplayName()
    this.lastMessageText = props.lastMessageText || ''
  }

  private getPlatform(): 'line' | 'facebook' | 'whatsapp' | 'instagram' | 'linkedin' | 'mobileWebview' | 'webchat' | 'unknown' {
    if (this.lineUserId) return 'line'
    if (this.facebookUserId) return 'facebook'
    if (this.whatsappUserId) return 'whatsapp'
    if (this.instagramUserId) return 'instagram'
    if (this.linkedinUserId) return 'linkedin'
    if (this.mobileWebviewUserId) return 'mobileWebview'
    if (this.webchatUserId) return 'webchat'
    return 'unknown'
  }

  private getDisplayName(): string {
    if (this.name) return this.name
    if (this.lineUserId) return this.lineUserId
    if (this.facebookUserId) return this.facebookUserId
    if (this.whatsappUserId) return this.whatsappUserId
    if (this.instagramUserId) return this.instagramUserId
    if (this.linkedinUserId) return this.linkedinUserId
    if (this.mobileWebviewUserId) return this.mobileWebviewUserId
    if (this.webchatUserId) return this.webchatUserId
    return 'Unknown Contact'
  }
}

// For DTO Chat History
export interface IModelChatHistoryResponse {
  messageIncomeId: string
  role: 'user' | 'bot' | 'assistant'
  content: string
  timestamp: string | Date
  messageType: 'text' | 'image' | 'file' | 'audio'
  socialName: 'LINE' | 'FACEBOOK' | 'WHATSAPP' | 'WECHAT' | 'INSTAGRAM' | 'LINKEDIN'
  category: string | null
}

export class ModelChatHistory {
  messageIncomeId: string
  role: 'user' | 'bot' | 'assistant'
  content: string
  timestamp: string | Date
  messageType: 'text' | 'image' | 'file' | 'audio'
  socialName: 'LINE' | 'FACEBOOK' | 'WHATSAPP' | 'WECHAT' | 'INSTAGRAM' | 'LINKEDIN'
  category: string | null

  displayTimestamp: string
  isUserMessage: boolean

  constructor(props = {} as IModelChatHistoryResponse) {
    props = props ?? ({} as IModelChatHistoryResponse)
    this.messageIncomeId = props.messageIncomeId || ''
    this.role = props.role || 'user'
    this.content = convertMarkdownToHtml(props.content || '')
    this.timestamp = props.timestamp || ''
    this.messageType = props.messageType || 'text'
    this.socialName = props.socialName || 'LINE'
    this.category = props.category || null

    this.displayTimestamp = displayDate(this.timestamp, { isTime: true })
    this.isUserMessage = this.role === 'user'
  }
}

// For DTO Manual Set State (handoff to agent)
export interface IModelManualSetStateRequest {
  userId: string
  category?: string
  language?: string
  channelId?: string
}

export interface IModelManualSetStateResponse {
  userId: string
  externalUserId: string
  engagementType: 'line' | 'facebook' | 'whatsapp' | 'instagram' | 'linkedin'
  socialName: string
  previousState: string
  state: string
  engagementId: string
  setStateStatus: number
  setStateResponse: any
}

// For DTO Manual Handoff (webchat / mobile webview — TG-social-webchat-service)
export interface IModelManualHandoffRequest {
  userId: string
  category?: string
}

export interface IModelManualHandoffResponse {
  ticketId?: string
  state: string
  status: string
  [key: string]: any
}
